<app-modal *ngIf="vo$ | async; let vo" (triggerClose)="close()">
	<mat-stepper modal-body
							 [linear]="true"
							 [selectedIndex]="vo.currentStep"
							 (selectionChange)="changeCurrentStep($event)"
							 (animationDone)="onStepReady()">
		<!--	Data source Columns selection  Step		-->
		<mat-step #step1 [completed]="
				vo.currentStep > ColumnConfigStep.ColumnsSelection ||
				(vo.currentStep === ColumnConfigStep.ColumnsSelection && vo.currentError === undefined)
				">
			<ng-template matStepperIcon="edit">
				<mat-icon
					*ngIf="step1.completed">
					done</mat-icon>
			</ng-template>

			<ng-template matStepLabel>
				<span
					i18n="@@expositions.stepper.columns">
					columns</span>
			</ng-template>

			<ng-template matStepContent>
				<app-panel
					class="app-card-outline__columns"
					headerHeight="3rem"
					isAlwaysOpen="true"
					hasSearchableGrid="true"
					hasRefresh="true"
					(refresh)="fetchColumns()"
					[actionsAvailable]="columnsGrid.selectionCount"
					[itemsCount]="vo.list.elements.size"
					(search)="columnsGrid.search($event)">
				<span
					panel-title i18n="@@exposition.access.list.column.columns">
					columns
				</span>

					<div panel-info class="activated-columns-alert">
						<div *ngIf="vo.columnsConfig.elements.size !== 0" class="activated-columns-alert">
							<span>{{ vo.columnsConfig.elements.size }}&#32;</span>
							<span i18n="@@expositions.columns.config.selectedElements">
							Elements selectionnée
						</span>
						</div>
						<div
							*ngIf="vo.listErrors.size === 0"
							class="activated-columns-alert warn">
							<mat-icon [svgIcon]="DcIcons.Warning"></mat-icon>
							<span
								i18n="@@expositions.columns.config.alert.activatedColumns">
							activated columns used in access</span>
						</div>
					</div>

					<app-exposition-columns-config
						#columnsSelectionGrid
						#columnsGrid="ColumnsGrid"
						[columnConfigList]="vo.list"
						[isInViewMode]="false"
						[isInAccessConfigMode]="false"
						[columnConfigMode]="'SELECTION'"
						(errors)="modifyColumnConfigValidity($event)"></app-exposition-columns-config>
				</app-panel>
			</ng-template>
		</mat-step>

		<!--	Columns configuration & order  Step		-->
		<mat-step [completed]="
				vo.currentStep > ColumnConfigStep.ColumnsConfig ||
				(vo.currentStep === ColumnConfigStep.ColumnsConfig && vo.currentError === undefined)
				">
			<ng-template matStepLabel>
				<span
					i18n="@@expositions.stepper.columnsConfig">
					columns</span>
			</ng-template>

			<ng-template matStepContent>
				<app-exposition-columns-config-extended
					[columnConfigList]="vo.columnsConfig"></app-exposition-columns-config-extended>
			</ng-template>

		</mat-step>
	</mat-stepper>



	<div modal-footer class="app-expositions-columns-modal__footer">
		<div *ngIf="vo.currentError" class="error-alert">
			<mat-icon
				[ngClass]="{ warning: vo.currentError.type === 'warning' }"
				color="warn"
				[svgIcon]="
					vo.currentError.type === 'critic' ? DcIcons.Cancel : DcIcons.Warning
				"></mat-icon>
			<span>{{ vo.currentError.message }}</span>
		</div>


		<button
			*ngIf="vo.currentStep === ColumnConfigStep.ColumnsSelection"
			id="{{ cmpId }}-next-btn"
			class="app-exposition-stepper__footer-btn"
			mat-raised-button
			[disabled]="vo.currentError !== undefined"
			(click)="nextStep()"
			color="primary">
			<span i18n="@@general.stepper.next">Next</span>
		</button>

		<button
			*ngIf="vo.currentStep === ColumnConfigStep.ColumnsConfig"
			id="{{ cmpId }}-back-btn"
			mat-raised-button
			(click)="backStep()">
			<span i18n="@@general.stepper.back">Back</span>
		</button>

		<button
			*ngIf="vo.canEdit && vo.currentStep === ColumnConfigStep.ColumnsConfig"
			id="{{ cmpId }}-save-btn"
			[color]="'primary'"
			class="app-expositions-columns-modal__footer__btn"
			mat-raised-button
			[disabled]="vo.currentError !== undefined"
			(click)="save()">
			<mat-icon [svgIcon]="DcIcons.Save"></mat-icon>
			<span i18n="@@general.action.update">update</span>
		</button>
	</div>
</app-modal>
